import React from "react";
import Section from "./Section";
import { socials } from "../constants";
import { footerLinks } from '../constants'
import { companyLogos } from "../constants";

const Footer = () => {
  return (
    <Section id="about" crosses className="!px-0 !py-8  bg-[#a2cde9] bg-opacity-90">
     <div className="flex justify-center">
      <div className="container  flex justify-center items-center max-sm:flex-col ">
      
       
        <div className="flex mt-[-1rem] justify-center">
        <div className="flex flex-col items-center justify-center">
        
  {/* Social Media Icons */}
  <ul className="flex gap-5 flex-wrap justify-center">
  {companyLogos.map((logo, index) => (
      <a
      key={index}
        href="#"
        className="flex items-center justify-center"
      >
        <img src={logo} className="w-[3rem] sm:w-[5rem] md:w-[6rem] lg:w-[8rem] xl:w-[10rem]  h-auto"  />
      </a>
    ))}
  </ul>

  {/* Paragraph Text */}
  <p className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] font-semibold text-n-8 text-center mb-[5px] mt-[5px] leading-[1.5]">
    © {new Date().getFullYear()}. The Taiwan Polar Institute data repository is supported by the NSTC of Taiwan under grant numbers 112-2628-M-008-006 and 113-2116-M-008-024.
</p>

            
  
<ul className="flex items-center justify-center w-full lg:w-[70%] gap-5 flex-wrap">
    
          {socials.map((item) => (
            <a
              key={item.id}
              href={item.url}
              target="_blank"
              className="flex items-center  justify-center w-[2rem] sm:w-[2.5rem] lg:w-[3rem]  h-[2rem] sm:h-[2.5rem] lg:h-[3rem] bg-n-7 rounded transition-colors hover:bg-n-6"
            >
              <img src={item.iconUrl} className="w-[1.5rem] h-[1.5rem] sm:w-[2rem] sm:h-[2rem] lg:w-[2.2rem] lg:h-[2.2rem]"  style={{ filter: 'invert(100%)' }} alt={item.title} />
            </a>
          ))}
        </ul>
</div>

          
          </div>

        
      </div>
      </div>
    </Section>
  );
};

export default Footer;
